import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import useAuth from '../../../hooks/useAuth';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {

    const { user, logout } = useAuth();
    return (





        <Navbar bg="dark" expand="lg" >
            <Container >
                {/* <Navbar.Brand href="#">Navbar scroll</Navbar.Brand> */}
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-lg-0 "
                        style={{ maxHeight: '140px' }}
                        navbarScroll
                    >
                        {user.email ? <Nav.Link className="text-light" as={Link} to='/'>Home</Nav.Link> : ""}
                        {user.email ? <Nav.Link className="text-light" as={Link} to='/comments'>Comments</Nav.Link> : ""}
                        {user.email ? <Nav.Link className="text-light" as={Link} to='/logos'>Logos</Nav.Link> : ""}

                        {user.email ? <Nav.Link className="text-light" as={Link} to='/homeBanner'>HomeBanner</Nav.Link> : ""}

                        {user.email ? <Nav.Link className="text-light" as={Link} to='/ourProjects'>OurProjects</Nav.Link> : ""}
                        {user.email ? <Nav.Link className="text-light" as={Link} to='/onGoingProjects'>OnGoingProjects</Nav.Link> : ""}
                        {user.email ? <Nav.Link className="text-light" as={Link} to='/team'>Team</Nav.Link> : ""}
                    </Nav>
                    <div className="d-flex">

                        <Button onClick={logout} variant="secondary">LogOut</Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>


    )
};

export default AdminDashboard;
